import React, { FC } from 'react';
import ProjectDetailsFields from '../ProjectDetailsFields';
import ProjectConfidentialButton from '../ProjectConfidentialButton';
import Divider from '../../Divider';
import ProjectInformationFields from '../ProjectInformationFields';
import ProjectDatesFields from '../ProjectDatesFields';
import useTranslation from '../../../hooks/useTranslation';
import Text from '@ingka/text';
import { ProjectFormProps } from './ProjectFormProps';
import PartOfCrpForm from '../PartOfCrpForm';

const ProjectTabProjectForm: FC<ProjectFormProps> = ({
  projectList,
  isConfidentialAllowed,
  isep,
}) => {
  const t = useTranslation();
  return (
    <>
      <Text textStyle="Heading.S" tagName="h4">
        {t('labels.projectDetails')}
      </Text>
      <ProjectDetailsFields
        projectList={projectList}
        unifier={isep}
        type={'Relocation'}
      />
      {isConfidentialAllowed && <ProjectConfidentialButton />}
      <Divider />
      <PartOfCrpForm />
      <Divider />
      <ProjectInformationFields />
      <Divider />
      <ProjectDatesFields
        openingDate
        initialDates
        projectClosingDate
        isep={isep}
      />
    </>
  );
};

export default ProjectTabProjectForm;
